/** Frontmatter for the "rookie-draft-round-guide" article; the Body lives in rookie-draft-round-guide.jsx. */
const meta = {
  slug: 'rookie-draft-round-guide',
  title: 'Rookie Draft Guide 2026: What Camp and Preseason Week 1 Say About Where to Take Them',
  category: 'Draft',
  author: 'AndyDarkness',
  excerpt:
    'Every 2026 rookie worth a pick, with the round to take them in a 12-team half-PPR league, priced against where the market is actually drafting them. Current through preseason Week 1.',
  readMinutes: 12,
  date: '2026-08-19',
};

export default meta;
